export class CarouselModel {
  id: number;
  name: string;
  image: string;
  link: string;
  enabled: boolean;
  file: File;
  position: number;
}
